export default "__VITE_ASSET__CvNYJ$lB__"